import { useContext } from 'react';
import { Link } from 'react-router-dom';

import { CurrencyContext } from 'app/components/commons/Currency/CurrencyContext/CurrencyContext';
import { PictureComponent } from 'app/components/commons/PictureComponent/PictureComponent';
import { ProfilIcon } from 'app/components/commons/icons/DefaultProfile';
import type { BookingDetails } from 'app/typings/core/admin/bookings/booking';
import { GENDER } from 'app/typings/core/common/enum/gender';
import { format as formatDate } from 'app/utils/dayjs';
import { capitalizeFirstLetter } from 'app/utils/string';
import { pluralize } from 'app/utils/strings';

import styles from '../LeftPanel.module.scss';

type Props = {
  bookingDetails: BookingDetails;
};

export const User = ({ bookingDetails }: Props) => {
  const { userId, userData } = bookingDetails;
  const {
    firstName,
    lastName,
    gender,
    birthDate,
    bookings,
    giftCards,
    avatarPath,
  } = userData;

  const { currencyFormatter } = useContext(CurrencyContext);

  const getUserName = () => {
    if (!firstName || !lastName) {
      return `#${userId}`;
    }

    const hasGender = gender !== undefined && gender !== GENDER.OTHER;

    return hasGender
      ? `${capitalizeFirstLetter(gender)} ${firstName} ${lastName}`
      : `${firstName} ${lastName}`;
  };

  const totalAmount = bookings.amount + giftCards.amount;

  const staycationsSummary = [
    pluralize(bookings.count, 'booking', 'bookings'),
    pluralize(giftCards.count, 'card', 'cards'),
    currencyFormatter(totalAmount),
  ].join(' • ');

  return (
    <div className={styles.userInfo}>
      <div className={styles.userTitle}>User</div>
      <div className={styles.userDescription}>
        {avatarPath ? (
          <PictureComponent
            className={styles.userAvatar}
            pictureId={avatarPath}
          />
        ) : (
          <ProfilIcon />
        )}
        <div className={styles.userDetails}>
          <div className={styles.userName}>
            <Link
              className={styles.userLink}
              to={`/users/${userId}/edit`}
              target="_blank"
            >
              {getUserName()}
            </Link>
          </div>
          {birthDate && (
            <div className="birth-date">
              {formatDate(new Date(birthDate), 'DD/MM/YYYY')}
            </div>
          )}
          <div className="staycations">{staycationsSummary}</div>
        </div>
      </div>
    </div>
  );
};
